import React, { useState } from "react";
import axios from "axios";
import SideNav from "../Dashboard/SideNav";
import Navbar from "../Dashboard/Navbar";

const AddPackage = () => {
  const [formData, setFormData] = useState({
    title: "",
    price: "",
    duration: "",
    people: "",
    location: "",
    description: "",
    reviews: "",
    rating: "",
    province: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const provinces = ["Punjab", "Sindh", "Balochistan", "KPK", "Gilgit-Baltistan", "Azad-Kashmir"];

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (event) => {
    setImageFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const formDataWithImage = new FormData();
      formDataWithImage.append("title", formData.title);
      formDataWithImage.append("price", formData.price);
      formDataWithImage.append("duration", formData.duration);
      formDataWithImage.append("people", formData.people);
      formDataWithImage.append("location", formData.location);
      formDataWithImage.append("description", formData.description);
      formDataWithImage.append("reviews", formData.reviews);
      formDataWithImage.append("rating", formData.rating);
      formDataWithImage.append("province", formData.province);
      formDataWithImage.append("image", imageFile);

      await axios.post("https://journey-scape-main.vercel.app/api/auth/packages", formDataWithImage, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setIsLoading(false);
      setSuccessMessage("Package created successfully!");
      // Clear the form after successful submission
      setFormData({
        title: "",
        price: "",
        duration: "",
        people: "",
        location: "",
        description: "",
        reviews: "",
        rating: "",
        province: "",
      });
      setImageFile(null);
    } catch (error) {
      setIsLoading(false);
      console.error("Error creating package:", error);
      setErrorMessage("Failed to create package");
    }
  };

  return (
    <>
    <Navbar />
      <SideNav />
      <div className="db-info-wrap db-add-tour-wrap">
  <div className="row">
    <div className="container mt-4">
      <h2>Add Package</h2>
      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <form onSubmit={handleSubmit}>
        
        <div className="row">
        <div className="mb-3 col-md-6">
          <label htmlFor="title" className="form-label">
            Title
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="form-control"
            placeholder="Title"
            required
          />
        </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label htmlFor="price" className="form-label">
                Price
              </label>
              <input
                type="text"
                name="price"
                value={formData.price}
                onChange={handleChange}
                className="form-control"
                placeholder="Price"
                required
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label htmlFor="duration" className="form-label">
                Duration
              </label>
              <input
                type="text"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                className="form-control"
                placeholder="Duration"
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="mb-3">
              <label htmlFor="people" className="form-label">
                People
              </label>
              <input
                type="text"
                name="people"
                value={formData.people}
                onChange={handleChange}
                className="form-control"
                placeholder="People"
                required
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label htmlFor="location" className="form-label">
                Location
              </label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                className="form-control"
                placeholder="Location"
                required
              />
            </div>
          </div>
          <div className="col-md-5">
<div className="mb-3">
          <label htmlFor="image" className="form-label">
            Image
          </label>
          <input
            type="file"
            accept="image/*"
            name="image"
            onChange={handleImageChange}
            className="form-control"
            required
          />
        </div>
        </div>
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">
            Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="form-control"
            placeholder="Description"
            required
          ></textarea>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="mb-3">
              <label htmlFor="reviews" className="form-label">
                Reviews
              </label>
              <input
                type="number"
                name="reviews"
                value={formData.reviews}
                onChange={handleChange}
                className="form-control"
                placeholder="Reviews"
                required
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label htmlFor="rating" className="form-label">
                Rating
              </label>
              <input
                type="number"
                name="rating"
                value={formData.rating}
                onChange={handleChange}
                className="form-control"
                placeholder="Rating"
                required
              />
            </div>
          </div>
          <div className="col-md-6">
        <div className="mb-3">
          <label htmlFor="province" className="form-label">
            Province
          </label>
          <select
            name="province"
            value={formData.province}
            onChange={handleChange}
            className="form-control"
            required
          >
            <option value="">Select Province</option>
            {provinces.map((province) => (
              <option key={province} value={province}>
                {province}
              </option>
            ))}
          </select>
        </div>
        </div>
        </div>
        
        
        <button type="submit" className="btn btn-primary" disabled={isLoading}>
          {isLoading ? "Adding..." : "Add Package"}
        </button>
      </form>
    </div>
  </div>
</div>

    </>
  );
};

export default AddPackage;
